(function() {
    'use strict';
    function MwOutreachPreviewModal($translate) {
        this.$translate = $translate;

        this.dialogTitle = this.$translate.instant('icm-outreach__email-preview--preview-dialog-header');

        this.recipientLabel = this.$translate.instant('icm-outreach__email-preview--preview-dialog-label');
        this.pluralMergeFieldsLabel = this.$translate.instant('icm-outreach__email-preview--optional-fields-label');
        this.singularMergeFieldsLabel = this.$translate.instant('icm-outreach__email-preview--optional-field-label');
        this.firstNameLabel = this.$translate.instant('icm-outreach__email-preview--first-name-label');
        this.lastNameLabel = this.$translate.instant('icm-outreach__email-preview--last-name-label');

        this.okButtonText = this.$translate.instant('Send');
        this.cancelButtonText = this.$translate.instant('Cancel');

        this.mergeFieldsLabel = '';
        if (this.showFirstNameField && this.showLastNameField) {
            this.mergeFieldsLabel = this.pluralMergeFieldsLabel;
        }
        else {
            if (this.showFirstNameField || this.showLastNameField) {
                this.mergeFieldsLabel = this.singularMergeFieldsLabel;
            }
        }

        // --------------
        // Modal Actions
        // --------------
        this.cancelModal = function cancelModal() {
            this.cancelCallback();
        };

        this.okModal = function okModal() {
            if (this.previewForm.$valid && !this.previewForm.email.$invalid) {
                this.okCallback({data: this.data});
            }
        };
    }

    angular
        .module('MW.ContactManager.MwOutreachPreviewModal', [])
        .component('mwOutreachPreviewModal', {
            bindings: {
                cancelCallback: '&',
                okCallback: '&',
                emailPattern: '<',
                showFirstNameField: '<',
                showLastNameField: '<',
                data: '<'
            },
            controller: ['$translate', MwOutreachPreviewModal],
            template: `
                <mw-mini-modal-dialog layout="column" dialog-title="{{$ctrl.dialogTitle}}" ok="{{$ctrl.okButtonText}}" cancel="{{$ctrl.cancelButtonText}}" on-ok="$ctrl.okModal()" on-cancel="$ctrl.cancelModal()">
                    <mw-modal-content>
                        <ng-form name="$ctrl.previewForm">
                            <div layout="column">
                                <md-input-container class="recipient" md-is-error="$ctrl.previewForm.email.$dirty && $ctrl.previewForm.email.$invalid">
                                    <label>{{$ctrl.recipientLabel}}</label>
                                    <input required="" name="email" md-autofocus="true" ng-model="$ctrl.data.email" ng-pattern="$ctrl.emailPattern" />
                                </md-input-container>
                                <div layout="row" class="merge-field-description" ng-if="$ctrl.mergeFieldsLabel.length">{{$ctrl.mergeFieldsLabel}}</div>
                                <div layout="row">
                                    <md-input-container ng-if="$ctrl.showFirstNameField" class="first-name flex mw-flex-padding">
                                        <label>{{$ctrl.firstNameLabel}}</label>
                                        <input name="firstName" ng-model="$ctrl.data.firstName" md-autofocus="false" placeholder="John" />
                                    </md-input-container>
                                    <div layout="column" ng-if="$ctrl.showFirstNameField && $ctrl.showLastNameField" class="column-padding mw-flex-padding"></div>
                                    <md-input-container ng-if="$ctrl.showLastNameField" class="last-name flex mw-flex-padding">
                                        <label>{{$ctrl.lastNameLabel}}</label>
                                        <input name="lastName" ng-model="$ctrl.data.lastName" md-autofocus="false" placeholder="Smith" />
                                    </md-input-container>
                                </div>
                            </div>
                        </ng-form>
                    </mw-modal-content>
                </mw-mini-modal-dialog>
            `
        });
}());
